export enum EnumAutomationSchedulePreset {
  Daily = 'daily',
  Weekly = 'weekly',
  Monthly = 'monthly'
}
